module.exports = __webpack_public_path__ + "static/media/landingpage_p7.f7dd5677.jpeg";